import * as React from "react"
import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

const Loader = React.forwardRef(({ className, size = "default", ...props }, ref) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-12 w-12",
  }

  return (
    <Loader2
      ref={ref}
      className={cn("animate-spin text-primary", sizeClasses[size], className)}
      {...props}
    />
  )
})
Loader.displayName = "Loader"

// Full page loader with centered spinner
const PageLoader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex min-h-[200px] items-center justify-center",
      className
    )}
    {...props}
  >
    <Loader size="lg" />
  </div>
))
PageLoader.displayName = "PageLoader"

export { Loader, PageLoader }
